import React from "react";
import { CardsTable } from "../modules/Cards";
import { HeadLine } from "../modules/HeadLine";

const Cards = () => {
  return (
    <div style={{ flex: "80%", padding: "2rem" }}>
      <HeadLine
        headingText={"Cards"}
        tagLine={"A list of cards that you’ve sold already"}
      />
      <CardsTable />
    </div>
  );
};

Cards.propTypes = {};

export default Cards;
